import { render } from "./HomeHeader.vue?vue&type=template&id=189a48ee"
import script from "./HomeHeader.vue?vue&type=script&lang=js"
export * from "./HomeHeader.vue?vue&type=script&lang=js"

import "./HomeHeader.vue?vue&type=style&index=0&id=189a48ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__